module.exports = __webpack_public_path__ + "static/media/PM142.4b0c485c.png";